import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import moment from 'moment';

import AppService from './services/apps';
import ForumService from './services/forum';
import GalleryService from './services/galleries';
import KbService from './services/knowledge-base';
import PathService from './services/paths';
import TermService from './services/terms';
import UserService from './services/users';

Vue.use(Vuex);

const state = {
    appTitle: 'TTTC',
    appVersion: '0.0.1',
    loading: false,
    news: [],
    todos: [],
    courses: [],
    singleCourse: null,
    lessons: [],
    events: [],
    discussions: [],
    meetings: [],
    groups: [],
    student: {},
    person: {},
    transcript: {},
    video:null,
    timelineEvents: [],
    currentWeek: null,
    realCurrentWeek: null, // the actual week of the term even if the student has used the 'time machine' to switch weeks
    terms:null,
    currentTerm: null,
    uploadProgress: null,
    chatUsers:[],
    chatMessages: [],
    events: [],
    resources: [],
    messages: [],
    unreadMessages:0,
    chatSessions: [],
    unreadChatMessages: [],
    driveProgress: 0,
    forumCategories: [],
    kbCategories: [],
    currentUser: null,
    galleryViewerContext: null,
    settings: [],
    allTermTypes: [],
    allPaths: [],
    allApps: [],
    browserId: null,
    downloading: false
};

const mutations = {
    POPULATE(state, data) {
        if (data.type === 'chatUsers') {
            var users = data.data;
            for (let i = 0; i < users.length; i++) {
                Vue.set(state.chatUsers, i, users[i])
            }
        } else {
            state[data.type] = data.data;
        }
    },
    APPEND(state, data) {
        state[data.type] = state[data.type].concat(data.data);
    },
    PREPEND(state, data) {
        state[data.type] = data.data.concat(state[data.type]);
    },
    TOGGLE(state, data)  {
        state[data.type] = data.boolean;
    },
    PUSH(state, data)  {
        if (state[data.type].indexOf(data.data) === -1) {
            state[data.type].push(data.data);
        }
    },
    CONCAT(state, data)  {
        state[data.type] = state[data.type].concat(data.data);
    },
    SPLICE(state, data)  {
        let index = state[data.type].indexOf(data.data);
        state[data.type].splice(index,1);
    },
    REPLACE(state, data)  {
        // console.log(data.data.index);
        Vue.set(state[data.type], data.data.index, data.data.object);
        // console.log(state[data.type][data.data.index].selectedCourseSet);
    },
    INCREMENT(state, data) {
        state[data] = parseInt(state[data]) + 1;
    },
    DECREMENT(state, data) {
        state[data] = parseInt(state[data]) - 1;
    },

    REMOVE(state, data) {
        const index = state[data.type].findIndex(d => d.id === data.id);
        if (index >= 0) {
            state[data.type].splice(index, 1);
        }
    },
    UPDATE(state, data) {
        Object.keys(data.fields).forEach(function(key) {
            state[data.type][key] = data.fields[key];
        });
    },
    JOIN_CHAT(state, user) {
        var index = state.chatUsers.map(function(e) { return e.id; }).indexOf(parseInt(user.id));
        if (index > -1) {
            state.chatUsers[index].online = true;
        }
    },
    LEAVE_CHAT(state, id) {
        id = parseInt(id);
        var index = state.chatUsers.map(function(e) {return e.id; }).indexOf(id);
        if (index > -1) {
            state.chatUsers[index].online = false;
        }

    },
    ADD_MESSAGE(state, message) {
        let index = state.chatSessions.findIndex(function(s) {
            return s.id === message.conversationId;
        });
        if (index > -1) {
            state.chatSessions[index].messages.unshift(message);
        }

    },
    ADD_MESSAGES(state, messages) {
        if (messages.length < 1) return;
        let index = state.chatSessions.findIndex(function(s) {
            return s.id === messages[0].conversationId;
        });
        state.chatSessions[index].messages = state.chatSessions[index].messages.concat(messages);

    },
    NEW_REPLY(state, id) {
        console.log(state);
    },
    ADD_CHAT_SESSION(state, data) {
        var existing = state.chatSessions.findIndex(function(s) { return s.id === data.data.id});

        if (existing === -1) {
            state.chatSessions = state.chatSessions.concat(data.data);
        }

    },
    CLOSE_CHAT_SESSION(state, id) {
        let index = state.chatSessions.findIndex(function(s) {
            return s.id === id;
        })
        state.chatSessions.splice(index, 1);

    },
    // CHAT_MESSAGES(state, data) {
    //     console.log(data);
    //     var session = state.chatSessions.findIndex(function(s) {
    //         return s.id === data.data.id;
    //     });
    //     state.chatSessions[session].messages = state.chatSessions[session].messages.concat(data.data.messages);
    // },
    RESET(state, key) {
        state[key] = [];
    },
    UPDATE_FORUM_CATEGORIES(state, payload) {
        state.forumCategories = payload.categories;
    },
    UPDATE_CURRENT_USER(state, payload) {
        state.currentUser = payload.user;
    },
};

const actions = {
    populate({ commit }, data) {
        commit('POPULATE', data);
    },
    update({ commit }, data) {
        commit('UPDATE', data);
    },
    push({ commit }, data) {
        commit('PUSH', data);
    },
    concat({ commit }, data) {
        commit('CONCAT', data);
    },
    splice({ commit }, data) {
        commit('SPLICE', data);
    },
    replace({ commit }, data) {
        commit('REPLACE', data);
    },
    toggle({ commit }, data) {
        commit('TOGGLE', data);
    },
    append({ commit }, data) {
        commit('APPEND', data);
    },
    prepend({ commit }, data) {
        commit('PREPEND', data);
    },
    increment({ commit }, data) {
        commit('INCREMENT', data);
    },
    decrement({ commit }, data) {
        commit('DECREMENT', data);
    },
    remove({ commit }, data) {
        commit('REMOVE', data);
    },
    joinChat({ commit }, user) {
        commit('JOIN_CHAT', user);
    },
    leaveChat({ commit }, user) {
        commit('LEAVE_CHAT', user);
    },
    addMessage({ commit }, message) {
        commit('ADD_MESSAGE', message);
    },
    addMessages({ commit }, message) {
        commit('ADD_MESSAGES', message);
    },
    newReply({ commit }, id) {
        commit('NEW_REPLY', id)
    },
    reset({commit}, key) {
        commit('RESET', key)
    },
    addChatSession({commit}, data) {
        commit('ADD_CHAT_SESSION', data);
    },
    closeChatSession({commit}, data) {
        commit('CLOSE_CHAT_SESSION', data);
    },
    chatMessages({commit}, data) {
        commit('CHAT_MESSAGES', data)
    },

    async fetchForumCategories({ commit }) {
        const categories = await ForumService.getCategories();
        commit('UPDATE_FORUM_CATEGORIES', { categories });
    },
    async ensureForumCategories(context) {
        if (!context.state.forumCategories.length) {
            await context.dispatch('fetchForumCategories');
        }
    },

    async fetchKbCategories({ commit }) {
        const categories = await KbService.getCategories();
        commit('POPULATE', {
            type: 'kbCategories',
            data: categories,
        });
    },
    async ensureKbCategories(context) {
        if (!context.state.kbCategories.length) {
            await context.dispatch('fetchKbCategories');
        }
    },

    async fetchCurrentUser({ commit }) {
        const res = await UserService.getMe();
        if (res.data.success) {
            const user = res.data.person;
            commit('UPDATE_CURRENT_USER', { user });
        } else {
            console.log('failed to fetch current user:', res);
            throw new Error('failed to fetch current user');
        }
    },
    async ensureCurrentUser(context) {
        if (!context.state.currentUser) {
            await context.dispatch('fetchCurrentUser');
        }
    },

    pushGalleryViewerContext(context, params) {
        context.commit('POPULATE', {
            type: 'galleryViewerContext',
            data: params,
        });
    },
    popGalleryViewerContext(context) {
        let gvc = context.state.galleryViewerContext;
        context.commit('POPULATE', {
            type: 'galleryViewerContext',
            data: null,
        });
        return gvc;
    },

    async fetchAllTermTypes({ commit }) {
        commit('POPULATE', {
            type: 'allTermTypes',
            data: await TermService.getTermTypes(),
        });
    },
    async ensureAllTermTypes(context) {
        if (!context.state.allTermTypes.length) {
            await context.dispatch('fetchAllTermTypes');
        }
    },

    async fetchAllPaths({ commit }) {
        commit('POPULATE', {
            type: 'allPaths',
            data: await PathService.getPaths(),
        });
    },
    async ensureAllPaths(context) {
        if (!context.state.allPaths.length) {
            await context.dispatch('fetchAllPaths');
        }
    },

    async fetchAllApps({ commit }) {
        commit('POPULATE', {
            type: 'allApps',
            data: await AppService.getApps(),
        });
    },
    async ensureAllApps(context) {
        if (!context.state.allApps.length) {
            await context.dispatch('fetchAllApps');
        }
    },
};

const getters = {
    settings(state) {
        return state.settings;
    },
    driveProgress(state) {
        return state.driveProgress;
    },
    uploadProgress(state) {
        return state.uploadProgress;
    },
    loading(state) {
        return state.loading;
    },
    currentWeek(state) {
        return state.currentWeek;
    },
    terms(state) {
        return state.terms;
    },
    groups(state) {
        return state.groups;
    },
    currentTerm(state) {
        return state.currentTerm;
    },
    resources(state) {
        return state.resources;
    },
    events(state) {
        return state.events;
    },
    chatUsers(state) {
        return state.chatUsers;
    },
    messages(state) {
        return state.messages;
    },
    timelineEvents(state) {
        return state.timelineEvents;
    },
    unreadChatMessages(state) {
        return state.unreadChatMessages;
    },
    singleCourse: function(state) {
        return state.singleCourse;
    },
    chatSession(state, id) {
        return state.chatSessions
    },
    courses: function(state) {

        // function convertTo24Hour(time) {
        //     var hours = parseInt(time.substr(0, 2));
        //     if (time.indexOf('am') != -1 && hours == 12) {
        //         time = time.replace('12', '0');
        //     }
        //     if (time.indexOf('pm') != -1 && hours < 12) {
        //         time = time.replace(hours, (hours + 12));
        //     }

        //     return time.replace(/(am|pm)/, '').split(':')[0];
        // }

        // var days = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
        // var today = new moment();
        // var now = today.hour();

        // today = days[today.day()];
        // var courses = state.courses;

        // if (!Array.isArray(courses)) return;

        // courses.forEach(function(course, index) {
        //     if (!course.schedule) return;
        //     let weekdays = course.schedule.weekdays.day;

        //     if (typeof weekdays === 'string') weekdays = [weekdays]; // only happens one day a week

        //     weekdays.forEach(function(day) {
        //         if (day === today) {
        //             // if the class is today, make sure the start time has not already passed
        //             var startTime = convertTo24Hour(course.schedule.start_time);
        //             if (startTime > now) {
        //                 courses[index].isUpcoming = true;
        //             }
        //         }
        //     });
        // });
        return state.courses;
    },
    events: function(state) {

        function rgbToHex(red, green, blue) {
            var rgb = blue | (green << 8) | (red << 16);
            return '#' + (0x1000000 + rgb).toString(16).slice(1);
        }

        var events = state.events;

        events.forEach(function(event) {
            event.title = event.calname + ' -- ' + event.summary;

            var color = event.color;
            event.color = rgbToHex(color.red, color.green, color.blue);

            if (event.allday == 0) {
                event.allDay = false;
            } else if (event.allday == 1) {
                event.allDay = true;
            }

            delete event.allday;

            if (event.ownertype === 'INSTANCE') {
                var summary = event.summary.replace('-1', '');
                var course = state.courses.find((course) => course.abbrv === summary);
                if (course) {
                    var baseUrl = window.location.origin;
                    if (baseUrl == 'https://dev.tttc.ca') {
                        event.url = 'http://dev.tttc.ca/client/#/course/' + course.instanceid;
                    }
                    if (baseUrl == 'https://portal.tttc.ca') {
                        event.url = 'https://portal.tttc.ca/#/course/' + course.instanceid;
                    }
                    else {
                        event.url = 'http://localhost:8080/#/course/' + course.instanceid;
                    }
                }
            }

        });
        return events;
    },
    forumCategories(state) {
        return state.forumCategories;
    },
    kbCategories(state) {
        return state.kbCategories;
    },
    currentUser(state) {
        return state.currentUser;
    },
    allTermTypes(state) {
        return state.allTermTypes;
    },
    allPaths(state) {
        return state.allPaths;
    },
    allApps(state) {
        return state.allApps;
    },
};

const store = new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    // plugins: [createPersistedState({
    //     paths: ['student','courses']
    // })]

});

export default store;



// WEBPACK FOOTER //
// ./src/store.js